import React from "react";
import { Card } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Icon from "@material-ui/core/Icon";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import useTheme from "@material-ui/core/styles/useTheme";

const useStyles = makeStyles((theme) => {
  return {
    title: {
      color: theme.palette.primary.dark + " !important",
      fontSize: (props) => {
        if (theme.clientType == "desktop") {
          return props.active ? "30px" : "20px";
        } else {
          return props.active ? "20px" : "15px";
        }
      },
      fontWeight: 500,
      textTransform: "uppercase",
      opacity: (props) => (props.disabled ? 0.5 : 1),
      marginBottom: (props) => (props.disabled ? 0 : null),
      display: "flex",
      margin: 0,
      whiteSpace: "nowrap",
      alignItems: "center",
      "& .MuiIcon-root": {
        marginRight: theme.spacing(1),
      },
    },
    subHeader: {
      color: theme.palette.primary.dark + " !important",
      fontSize: theme.clientType == "desktop" ? "20px" : "15px",
      fontWeight: 500,
      textTransform: "uppercase",
      marginBottom: theme.spacing(0),
      //marginTop: theme.spacing(3)
    },
    listRoot: {
      marginBottom: theme.spacing(2),
    },
    cardRoot: {
      fontSize: "15px",
      padding: theme.clientType == "desktop" ? "32px" : 0,
    },
  };
});

export function CheckoutCard(props) {
  const classes = useStyles(props);
  return (
    <Card
      square={true}
      elevation={0}
      {...props}
      classes={{ root: classes.cardRoot }}
    />
  );
}

export function CheckoutCardTitle(props) {
  const classes = useStyles(props);
  const theme = useTheme();
  return (
    <Box
      pt={theme.clientType == "desktop" ? 0 : props.active ? 4 : 2}
      px={theme.clientType == "desktop" ? 0 : 3}
      pb={props.active || theme.clientType != "desktop" ? 1 : 0}
    >
      <Typography
        gutterBottom
        variant="h5"
        component="h2"
        className={classes.title}
      >
        {props.complete && <Icon color="secondary">check_circle</Icon>}
        {props.children}
      </Typography>
    </Box>
  );
}

export function CheckoutCardContent(props) {
  const theme = useTheme();
  return <Box px={theme.clientType == "desktop" ? 0 : 3} {...props} />;
}

export function CheckoutCardList(props) {
  const classes = useStyles();
  return <List classes={{ root: classes.listRoot }} {...props} />;
}

export function CheckoutCardSubHeader({ children }) {
  const classes = useStyles();

  return (
    <Typography
      gutterBottom
      variant="h5"
      component="h5"
      className={classes.subHeader}
    >
      {children}
    </Typography>
  );
}
